<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid>
        <b-row>
          <b-col md="1" sm="1" class="p-0">
            <label>Código</label>
            <b-form-input
              type="text"
              placeholder="Código"
              :disabled="this.modal_acao == 'u'"
              v-model="form.cd"
              name="cd"
            >
            </b-form-input>
            <b-form-feedback
              v-text="form.errors.get('cd')"
              v-if="form.errors.has('cd')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2" class="p-0">
            <label>Descrição</label>
            <b-form-input
              type="text"
              placeholder="Descrição"
              :disabled="this.modal_acao == 'u'"
              v-model="form.descr"
              name="descr"
            >
            </b-form-input>
            <b-form-feedback
              v-text="form.errors.get('descr')"
              v-if="form.errors.has('descr')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2" class="p-0">
            <label>Modal</label>
            <multiselect
              v-model="modal"
              :options="optionsModal"
              :disabled="this.modal_acao == 'u'"
              track-by="bmodal_id"
              label="label"
              :limit="10"
              :multiple="true"
              :clear-on-select="false"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder=""
              select-label=""
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('modal')"
              v-if="form.errors.has('modal')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2" class="p-0">
            <label>Tipo Cálculo</label>
            <multiselect
              v-model="tpCalcSelected"
              :options="optionsLivTpCalc"
              :disabled="this.modal_acao == 'u'"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder=""
              select-label=""
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('tp_calc')"
              v-if="form.errors.has('tp_calc')"
            ></b-form-feedback>
          </b-col>
          <b-col md="5" sm="5" class="p-0">
            <label>Fornecedor</label>
            <multiselect
              v-model="fornecedorSelected"
              :options-limit="300"
              :disabled="this.modal_acao == 'u'"
              :limit="2"
              :limit-text="limitText"
              :options="optionsFornecedor"
              track-by="value"
              label="label"
              id="fornecedor"
              :hide-selected="true"
              placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingFornecedor"
              @search-change="listaFornecedor"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('pessoa_id_for')"
              v-if="form.errors.has('pessoa_id_for')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="1" sm="1" class="p-0">
            <label>Tabela</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_tabela"
                :options="optionsTpTabela"
                :disabled="this.modal_acao == 'u'"
                name="tp_tabela"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_tabela')"
              v-if="form.errors.has('tp_tabela')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2" class="p-0">
            <label>Tipo</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_receita_despesa"
                :options="optionsLivTpReceitaDespesa"
                :disabled="this.modal_acao == 'u'"
                name="tp_receita_despesa"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_receita_despesa')"
              v-if="form.errors.has('tp_receita_despesa')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2" class="p-0">
            <label>Composição</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_composicao"
                :options="optionsLivTpComposicao"
                :disabled="this.modal_acao == 'u'"
                name="tp_composicao"
                plain
                stacked
                value-field="value"
                @input="ordenaTabelasFrete(form.tp_composicao)"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_composicao')"
              v-if="form.errors.has('tp_composicao')"
            ></b-form-feedback>
          </b-col>
          <b-col
            v-if="form.tp_composicao == 2 || form.tp_composicao == 3"
            md="3"
            sm="3"
            class="p-0"
          >
            <label>Tabela de frete</label>
            <multiselect
              v-model="tab_composicao"
              :options="optionsTabelaFreteRepopulada"
              :disabled="this.modal_acao == 'u'"
              track-by="value"
              label="label"
              :limit="10"
              :multiple="true"
              :clear-on-select="false"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('tab_composicao.value')"
              v-if="form.errors.has('tab_composicao.value')"
            ></b-form-feedback>
          </b-col>
          <b-col v-if="form.tp_receita_despesa == 1" md="4" sm="4" class="p-0">
            <label>Clientes</label>
            <multiselect
              v-model="pessoa"
              :options-limit="300"
              :limit="10"
              :multiple="true"
              :limit-text="limitText"
              :options="optionsPessoa"
              track-by="value"
              label="label"
              id="cliente"
              :hide-selected="true"
              placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingPessoa"
              @search-change="listaClientesPessoa"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('pessoa.value')"
              v-if="form.errors.has('pessoa.value')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" sm="12" class="p-0">
            <label class="panel-title">Observação tabela de frete</label>
            <b-form-textarea
              id="textarea1"
              name="obs"
              :disabled="this.modal_acao == 'u'"
              v-model="form.obs"
              placeholder="Observação"
              :rows="3"
              :max-rows="6"
            >
            </b-form-textarea>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="pt-1" fluid>
        <b-row>
          <b-col class="p-0">
            <div v-for="(row, index_rota) in rota">
              <b-col class="col-lg-1">
                <b-row>
                  <h3 class="header_destaque">Rota {{ row.num_rota }}</h3>
                  <i
                    class="fa fa-times"
                    style="cursor: pointer"
                    v-b-tooltip.hover.right="'Remover Rota'"
                    v-on:click="removeRowRota(index_rota)"
                  ></i>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col class="p-0">
                    <b-tabs>
                      <b-tab title="Trajeto" active>
                        <b-col>
                          <b-row>
                            <b-col class="p-0">
                              <label>Município Origem</label>
                              <multiselect
                                v-model="row.municipio_origem"
                                :options="optionsMunicipio"
                                track-by="value"
                                label="label"
                                @input="
                                  defineOrigemDestino(
                                    index_rota,
                                    row.municipio_origem,
                                    1,
                                    1
                                  )
                                "
                                :disabled="
                                  row.disabled_municipio_origem == true
                                "
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'rota.' + index_rota + '.municipio_origem'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'rota.' + index_rota + '.municipio_origem'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                            <b-col class="p-0">
                              <label>Município Fim</label>
                              <multiselect
                                v-model="row.municipio_destino"
                                :options="optionsMunicipio"
                                track-by="value"
                                label="label"
                                @input="
                                  defineOrigemDestino(
                                    index_rota,
                                    row.municipio_destino,
                                    1,
                                    2
                                  )
                                "
                                :disabled="
                                  row.disabled_municipio_destino == true
                                "
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'rota.' + index_rota + '.municipio_destino'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'rota.' + index_rota + '.municipio_destino'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                            <b-col class="p-0">
                              <label>Regiao Origem</label>
                              <multiselect
                                v-model="row.regiao_origem"
                                :options="optionsRegiao"
                                track-by="value"
                                label="label"
                                @input="
                                  defineOrigemDestino(
                                    index_rota,
                                    row.regiao_origem,
                                    2,
                                    1
                                  )
                                "
                                :disabled="row.disabled_regiao_origem == true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'rota.' + index_rota + '.regiao_origem'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'rota.' + index_rota + '.regiao_origem'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                            <b-col class="p-0">
                              <label>Regiao Fim</label>
                              <multiselect
                                v-model="row.regiao_destino"
                                :options="optionsRegiao"
                                track-by="value"
                                label="label"
                                @input="
                                  defineOrigemDestino(
                                    index_rota,
                                    row.regiao_destino,
                                    2,
                                    2
                                  )
                                "
                                :disabled="row.disabled_regiao_destino == true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback
                                class="text-danger"
                                v-text="
                                  form.errors.get(
                                    'rota.' + index_rota + '.regiao_destino'
                                  )
                                "
                                v-if="
                                  form.errors.has(
                                    'rota.' + index_rota + '.regiao_destino'
                                  )
                                "
                              ></b-form-feedback>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-tab>
                      <b-tab title="Transporte">
                        <div class="table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th style="width: 20%">Tipo</th>
                                <th style="width: 15%">Carroceria</th>
                                <th style="width: 20%">Carga Perigosa?</th>
                                <th style="width: 20%">Refrigerado?</th>
                                <th style="width: 10%">Status</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row_transp, index_transp) in row.transp"
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <b-col class="p-0">
                                    <multiselect
                                      v-model="row_transp.tp_rodado"
                                      :options="optionsParamTipoRodado"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.tp_rodado.value'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.tp_rodado.value'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <multiselect
                                      v-model="row_transp.carroceria"
                                      :options="optionsCarroceria"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.carroceria.value'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.carroceria.value'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        v-model="row_transp.carga_perigosa"
                                        :options="optionsCargaPerigosa"
                                        :name="'carga_perigosa' + index_transp"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.carga_perigosa'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.carga_perigosa'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        v-model="row_transp.refrigerado"
                                        :options="optionsRefrigerado"
                                        :name="'refrigerado' + index_transp"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.refrigerado'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.refrigerado'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        v-model="row_transp.status"
                                        :options="optionsStatusVeiculo"
                                        :name="'status_transp' + index_transp"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.status'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.transp.' +
                                            index_transp +
                                            '.status'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <i
                                    class="fa fa-times"
                                    style="cursor: pointer"
                                    v-b-tooltip.hover.right="'Remover Linha'"
                                    v-on:click="
                                      removeRowTransp(index_rota, index_transp)
                                    "
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                            <td colspan="5"></td>
                            <td>
                              <i
                                class="fa fa-plus-square"
                                v-on:click="addRowTransp(index_rota, $event)"
                                v-b-tooltip.hover.right="'Adicionar Linha'"
                                style="cursor: pointer"
                              ></i>
                            </td>
                          </table>
                        </div>
                      </b-tab>
                      <b-tab title="Carga">
                        <div class="table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th style="width: 30%">Tipo Carga</th>
                                <th style="width: 30%">Tipo</th>
                                <th style="width: 20%">Status</th>
                                <th style="width: 20%">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row_carga, index_carga) in row.carga"
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <b-col class="p-0">
                                    <multiselect
                                      v-model="row_carga.param_tipo_carga"
                                      :options="optionsParamTipoCarga"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            index_carga +
                                            '.param_tipo_carga.value'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.carga.' +
                                            index_carga +
                                            '.param_tipo_carga.value'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <multiselect
                                      v-model="row_carga.tp_carga"
                                      :options="optionsTpCarga"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                    ></multiselect>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.carga.' +
                                            index_carga +
                                            '.tp_carga.value'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.carga.' +
                                            index_carga +
                                            '.tp_carga.value'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        v-model="row_carga.status"
                                        :options="optionsStatusCarga"
                                        :name="'status_carga' + index_carga"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="
                                        form.errors.get(
                                          'rota.' +
                                            index_rota +
                                            '.carga.' +
                                            index_carga +
                                            '.status'
                                        )
                                      "
                                      v-if="
                                        form.errors.has(
                                          'rota.' +
                                            index_rota +
                                            '.carga.' +
                                            index_carga +
                                            '.status'
                                        )
                                      "
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <i
                                    class="fa fa-times"
                                    style="cursor: pointer"
                                    v-b-tooltip.hover.right="'Remover Linha'"
                                    v-on:click="
                                      removeRowCarga(index_rota, index_carga)
                                    "
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                            <td colspan="3"></td>
                            <td>
                              <i
                                class="fa fa-plus-square"
                                v-on:click="addRowCarga(index_rota, $event)"
                                v-b-tooltip.hover.right="'Adicionar Linha'"
                                style="cursor: pointer"
                              ></i>
                            </td>
                          </table>
                        </div>
                      </b-tab>
                      <b-tab title="Caracteristicas">
                        <div class="table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th style="width: 10%">Tipo de Operação</th>
                                <th style="width: 90%">Tipo de Processo</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        :options="optionsTpOperacao"
                                        v-model="row.tp_operacao"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-feedback
                                      class="text-danger"
                                      v-text="form.errors.get('tp_operacao')"
                                      v-if="form.errors.get('tp_operacao')"
                                    ></b-form-feedback>
                                  </b-col>
                                </td>
                                <td>
                                  <b-col class="p-0">
                                    <b-form-group>
                                      <b-form-radio-group
                                        :options="optionsTpProcesso"
                                        v-model="row.tp_processo"
                                        plain
                                        stacked
                                        value-field="value"
                                      ></b-form-radio-group>
                                      <b-form-feedback
                                        class="text-danger"
                                        v-text="form.errors.get('tp_processo')"
                                        v-if="form.errors.get('tp_processo')"
                                      ></b-form-feedback>
                                    </b-form-group>
                                  </b-col>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="pt-1">
                <div v-for="(row_vig, index_vig) in row.vigencia">
                  <b-row>
                    <h3 class="header_destaque">
                      Vigência
                      <span
                        class="badge badge-warning"
                        v-if="row_vig.status == 1"
                        >Pendente</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="row_vig.status == 2"
                        >Aprovada</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="row_vig.status == 3"
                        >Cancelada</span
                      >
                    </h3>
                    <i
                      class="fa fa-plus-square"
                      v-on:click="addRowVigencia(index_rota, row_vig, $event)"
                      v-b-tooltip.hover.right="'Adicionar Vigência'"
                      style="cursor: pointer"
                    ></i>
                    <i
                      v-if="index_vig !== 0"
                      class="fa fa-times"
                      style="cursor: pointer"
                      v-b-tooltip.hover.right="'Remover Vigência'"
                      v-on:click="removeRowVigencia(index_rota, index_vig)"
                    ></i>
                  </b-row>
                  <b-row>
                    <b-col class="col-md-3 p-0">
                      <label></label>
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Data Inicial"
                        v-model="row_vig.dt_vigencia_ini"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.dt_vigencia_ini'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.dt_vigencia_ini'
                          )
                        "
                      ></b-form-feedback>
                    </b-col>
                    <b-col class="col-md-3 p-0">
                      <label></label>
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Data Fim"
                        v-model="row_vig.dt_vigencia_fim"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.dt_vigencia_fim'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.dt_vigencia_fim'
                          )
                        "
                      ></b-form-feedback>
                    </b-col>
                    <b-col class="col-md-6 p-0">
                      <label>Observação</label>
                      <input
                        placeholder="Obs. "
                        type="text"
                        class="form-control"
                        v-model="row_vig.obs_vigencia"
                        v-mask="'##/##/####'"
                        @keyup.enter="doFilter"
                      />
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.obs_vigencia'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'rota.' +
                              index_rota +
                              '.vigencia.' +
                              index_vig +
                              '.obs_vigencia'
                          )
                        "
                      ></b-form-feedback>
                    </b-col>
                  </b-row>
                  <b-tabs class="pt-1 p-0">
                    <b-tab title="Cálculo">
                      <div>
                        <table class="table">
                          <thead>
                            <tr>
                              <th style="width: 10%">Vlr. Início</th>
                              <th style="width: 10%">Vlr. Fim</th>
                              <th style="width: 10%">Valor</th>
                              <th style="width: 5%">Fixa</th>
                              <th style="width: 5%">Excedente</th>
                              <th style="width: 10%">Vlr. Excedente</th>
                              <th style="width: 10%">Fator Conv.</th>
                              <th style="width: 5%">Status</th>
                              <th style="width: 5%">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(row_calc, index_calc) in row_vig.calculo"
                              style="display: table-row"
                            >
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_calc.vlr_ini"
                                    :auto-decimal-mode="true"
                                    :precision="3"
                                    :disabled="
                                      tpCalcSelected.value == 7 ||
                                      tpCalcSelected.value == 5 ||
                                      tpCalcSelected.value == 4
                                    "
                                    placeholder="Vlr. Início"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_ini'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_ini'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_calc.vlr_fim"
                                    :auto-decimal-mode="true"
                                    :precision="3"
                                    :disabled="
                                      tpCalcSelected.value == 7 ||
                                      tpCalcSelected.value == 5 ||
                                      tpCalcSelected.value == 4
                                    "
                                    placeholder="Vlr fim"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_fim'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_fim'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_calc.vlr"
                                    :auto-decimal-mode="true"
                                    :precision="3"
                                    placeholder="Valor"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <b-form-checkbox
                                    v-model="row_calc.fixa"
                                    :name="'fixa' + index_calc"
                                    :disabled="
                                      tpCalcSelected.value == 7 ||
                                      tpCalcSelected.value == 5 ||
                                      tpCalcSelected.value == 4
                                    "
                                    value="1"
                                    unchecked-value="0"
                                  >
                                  </b-form-checkbox>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.fixa'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.fixa'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <b-form-checkbox
                                    v-model="row_calc.excedente"
                                    :name="'excedente' + index_calc"
                                    value="1"
                                    :disabled="
                                      tpCalcSelected.value == 7 ||
                                      tpCalcSelected.value == 5 ||
                                      tpCalcSelected.value == 4
                                    "
                                    unchecked-value="0"
                                  >
                                  </b-form-checkbox>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.excedente'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.excedente'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    :disabled="
                                      row_calc.excedente == 0 ||
                                      tpCalcSelected.value == 5 ||
                                      tpCalcSelected.value == 7 ||
                                      tpCalcSelected.value == 4
                                    "
                                    v-model="row_calc.vlr_exd"
                                    :auto-decimal-mode="true"
                                    placeholder="Vlr. Excedente"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_exd'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.vlr_exd'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_calc.fator_conv"
                                    :auto-decimal-mode="true"
                                    placeholder="Fator Conv."
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.fator_conv'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.fator_conv'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <b-form-group>
                                    <b-form-radio-group
                                      v-model="row_calc.status"
                                      :options="optionsLivStatusCalc"
                                      :name="'status' + index_vig + index_calc"
                                      plain
                                      stacked
                                      value-field="value"
                                    ></b-form-radio-group>
                                  </b-form-group>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.status'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia' +
                                          index_vig +
                                          '.calculo.' +
                                          index_calc +
                                          '.status'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <i
                                  v-if="index_calc !== 0"
                                  class="fa fa-times"
                                  style="cursor: pointer"
                                  v-b-tooltip.hover.right="'Remover Linha'"
                                  v-on:click="
                                    removeRowCalculo(
                                      index_rota,
                                      index_vig,
                                      index_calc
                                    )
                                  "
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                          <td colspan="8"></td>
                          <td>
                            <i
                              class="fa fa-plus-square"
                              v-on:click="
                                addRowCalculo(index_rota, index_vig, $event)
                              "
                              v-b-tooltip.hover.right="'Adicionar Linha'"
                              style="cursor: pointer"
                            ></i>
                          </td>
                        </table>
                      </div>
                    </b-tab>
                    <b-tab title="TDA/TDE" class="pl-1 pr-1">
                      <b-row>
                        <b-col class="p-0">
                          <label>Tipo taxa TDE</label>
                          <multiselect
                            v-model="row_vig.tp_taxa_tde"
                            :options="optionsTaxaTpTaxaTde"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_tde.value'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_tde.value'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Tipo taxa TDA</label>
                          <multiselect
                            v-model="row_vig.tp_taxa_tda"
                            :options="optionsTaxaTpTaxaTda"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_tda.value'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_tda.value'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Status</label>
                          <b-form-group>
                            <b-form-radio-group
                              v-model="row.status"
                              :options="optionsTaxaStatus"
                              :name="'status_taxa' + index_vig"
                              plain
                              stacked
                              value-field="value"
                            ></b-form-radio-group>
                          </b-form-group>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.status'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.status'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="p-0">
                          <label>Taxa TDA</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_tda"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_tda'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_tda'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor fixo TDA</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_fixo_tda"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_fixo_tda'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_fixo_tda'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="p-0">
                          <label>Taxa TDE</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_tde"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_tde'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_tde'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor fixo TDE</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_fixo_tde"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_fixo_tde'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_fixo_tde'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="Pedágio" class="pl-1 pr-1">
                      <b-row>
                        <b-col class="p-0">
                          <label>Tipo taxa pedágio</label>
                          <multiselect
                            v-model="row_vig.tp_taxa_pedagio"
                            :options="optionsTaxaTpTaxaPedagio"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_pedagio.value'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.tp_taxa_pedagio.value'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Pedágio por fração de</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_pedagio"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_pedagio'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_pedagio'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor pedágio</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_pedagio"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_pedagio'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_pedagio'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="Outros" class="pl-1 pr-1">
                      <b-row>
                        <b-col class="p-0">
                          <label>Taxa Gris</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_gris"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_gris'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_gris'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Taxa Devolução</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_devolucao"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_devolucao'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_devolucao'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Taxa Reentrega</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.taxa_reentrega"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_devolucao'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.taxa_devolucao'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="p-0">
                          <label>Valor TAS</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_tas"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_tas'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_tas'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor despacho</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_despacho"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_despacho'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_despacho'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor SEC/CAT</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_sec_cat"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_sec_cat'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_sec_cat'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor agendamento</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_agendamento"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_agendamento'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_agendamento'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor outros</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_outros"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_outros'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_outros'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Ad Valorem</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.ad_valorem"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.ad_valorem'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.ad_valorem'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Minimo Advalorem</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_minimo_advalorem"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.ad_valorem'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.ad_valorem'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Minimo Gris</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_minimo_gris"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_minimo_gris'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_minimo_gris'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Valor minimo por rota</label>
                          <currency-input
                            class="form-control"
                            v-model="row_vig.vlr_qtde_docs_fiscais"
                            placeholder="Valor"
                            :auto-decimal-mode="true"
                            :currency="{ prefix: '' }"
                            :distraction-free="getCurrency"
                          />
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_qtde_docs_fiscais'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.vlr_qtde_docs_fiscais'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                        <b-col class="p-0">
                          <label>Quantidade de notas</label>
                          <b-form-input
                            type="number"
                            placeholder="Quantidade de notas"
                            v-model="row_vig.qtde_docs_fiscais"
                            name="qtde_docs_fiscais"
                          >
                          </b-form-input>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.qtde_docs_fiscais'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.qtde_docs_fiscais'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12" sm="12" class="p-0">
                          <label class="panel-title">Observação</label>
                          <b-form-textarea
                            id="textarea_obs"
                            name="obs"
                            v-model="row_vig.obs_valores"
                            placeholder="Observação"
                            :rows="3"
                            :max-rows="6"
                          >
                          </b-form-textarea>
                          <b-form-feedback
                            class="text-danger"
                            v-text="
                              form.errors.get(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.obs_valores'
                              )
                            "
                            v-if="
                              form.errors.has(
                                'rota.' +
                                  index_rota +
                                  '.vigencia.' +
                                  index_vig +
                                  '.obs_valores'
                              )
                            "
                          ></b-form-feedback>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="Custo">
                      <div class="table">
                        <table class="table">
                          <thead>
                            <tr>
                              <th style="width: 15%">Tipo trecho</th>
                              <th style="width: 15%">Tipo trecho custo</th>
                              <th style="width: 15%">Taxa</th>
                              <th style="width: 15%">% Taxa</th>
                              <th style="width: 15%">Valor minimo</th>
                              <th style="width: 15%">Custo</th>
                              <th style="width: 10%">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                row_custo, index_custo_extra
                              ) in row_vig.custo_extra"
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <b-col class="p-0">
                                  <multiselect
                                    v-model="row_custo.tp_trecho"
                                    :options="optionsExtraTpTrecho"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.tp_trecho.value'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.tp_trecho.value'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <multiselect
                                    v-model="row_custo.tp_trecho_custo"
                                    :options="optionsExtraTpTrechoCusto"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.tp_trecho_custo.value'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.tp_trecho_custo.value'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_custo.vlr_taxa"
                                    :auto-decimal-mode="true"
                                    placeholder="Taxa"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.vlr_taxa'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.vlr_taxa'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_custo.taxa_comissao"
                                    :auto-decimal-mode="true"
                                    placeholder="Taxa Comissão"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.taxa_comissao'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.taxa_comissao'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <currency-input
                                    class="form-control"
                                    v-model="row_custo.vlr_minimo"
                                    :auto-decimal-mode="true"
                                    placeholder="Valor minimo"
                                    :currency="{ prefix: '' }"
                                    :distraction-free="getCurrency"
                                  />
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.vlr_minimo'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.vlr_minimo'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <b-col class="p-0">
                                  <multiselect
                                    v-model="row_custo.custo"
                                    :options="optionsCusto"
                                    track-by="value"
                                    label="label"
                                    :hide-selected="true"
                                    placeholder="Selecione"
                                    tag-placeholder="Selecionar"
                                    select-label="Selecionar"
                                    selected-label="Selecionado"
                                    deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback
                                    class="text-danger"
                                    v-text="
                                      form.errors.get(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.custo.value'
                                      )
                                    "
                                    v-if="
                                      form.errors.has(
                                        'rota.' +
                                          index_rota +
                                          '.vigencia.' +
                                          index_vig +
                                          '.custo_extra.' +
                                          index_custo_extra +
                                          '.custo.value'
                                      )
                                    "
                                  ></b-form-feedback>
                                </b-col>
                              </td>
                              <td>
                                <i
                                  class="fa fa-times"
                                  style="cursor: pointer"
                                  v-b-tooltip.hover.right="'Remover Linha'"
                                  v-on:click="
                                    removeRowCustoExtra(
                                      index_rota,
                                      index_vig,
                                      index_custo_extra
                                    )
                                  "
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                          <td colspan="4"></td>
                          <td>
                            <i
                              class="fa fa-plus-square"
                              v-on:click="
                                addRowCustoExtra(index_rota, index_vig, $event)
                              "
                              v-b-tooltip.hover.right="'Adicionar Linha'"
                              style="cursor: pointer"
                            ></i>
                          </td>
                        </table>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-col>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <div class="float-left pr-1" v-if="this.errors_array.length > 0">
          <b-btn
            class="badge badge-warning"
            @click="showPopover = !showPopover"
            id="popoverButton-sync"
            v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'"
            variant="warning"
            ><i class="fa fa-exclamation-triangle fa-2x"></i
          ></b-btn>

          <b-popover
            :show.sync="showPopover"
            target="popoverButton-sync"
            title="<strong>Erros Encontrados</strong>"
            html="true"
            placement="leftbottom"
          >
            <table class="table-striped" id="mais">
              <tbody>
                <tr
                  class="bg-gray-light"
                  style="display: table-row"
                  v-for="item in this.errors_array"
                >
                  <td>
                    {{ item.erro }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-popover>
        </div>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: ""
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      showPopover: false,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingPessoa: false,
      isLoadingFornecedor: false,
      fornecedorSelected: [],
      tpCalcSelected: [],
      optionsTpTabela: [],
      optionsStatusVigencia: [],
      optionsTpOperacao: [],
      optionsTpProcesso: [],
      optionsStatusVeiculo: [],
      optionsCargaPerigosa: [],
      optionsRefrigerado: [],
      optionsParamTipoRodado: [],
      optionsParamTipoCarga: [],
      optionsTpCarga: [],
      optionsStatusCarga: [],
      optionsTaxaStatus: [],
      optionsTaxaTpTaxaTde: [],
      optionsTaxaTpTaxaTda: [],
      optionsTaxaTpTaxaPedagio: [],
      optionsStatusPessoa: [],
      optionsPessoa: [],
      optionsFornecedor: [],
      optionsExtraTpTrecho: [],
      optionsExtraTpTrechoCusto: [],
      optionsCarroceria: [],
      optionsModal: [],
      optionsLivTpComposicao: [],
      optionsLivTpReceitaDespesa: [],
      optionsLivTpCalc: [],
      optionsCusto: [],
      carroceria: [],
      optionsTabelaFrete: [],
      optionsMunicipio: [],
      optionsLivStatusCalc: [],
      optionsRegiao: [],
      optionsTabelaFreteRepopulada: [],
      errors_array: [],
      modal: [],
      pessoa: [],
      vigencia: [],
      calculo: [],
      tab_composicao: [],
      rota: [
        {
          num_rota: 1,
          status: "",
          municipio_origem: [],
          municipio_destino: [],
          regiao_origem: [],
          regiao_destino: [],
          tabfrerot_id: "",
          tp_origem: 0,
          tp_destino: 0,
          disabled_municipio_origem: false,
          disabled_municipio_destino: false,
          disabled_regiao_origem: false,
          disabled_regiao_destino: false,
          tp_operacao: 1,
          tp_processo: 1,
          transp: [
            {
              tp_rodado: [],
              carga_perigosa: 2,
              tafrvivei_id: "",
              refrigerado: 2,
              carroceria: [],
              tafrerotvivei_id: "",
              status: 1
            }
          ],
          carga: [
            {
              tp_carga: [],
              tafrvica_id: "",
              status: 1,
              param_tipo_carga: [],
              tafrvica_id: ""
            }
          ],
          vigencia: [
            {
              num_vig: "",
              dt_vigencia_ini: "",
              dt_vigencia_fim: "",
              obs_vigencia: "",
              num_vig: 1,
              tp_taxa_tde: [],
              tp_taxa_tda: [],
              tp_taxa_pedagio: [],
              status_taxa: [],
              taxa_gris: 0,
              taxa_devolucao: 0,
              taxa_reentrega: 0,
              taxa_tda: 0,
              taxa_tde: 0,
              vlr_fixo_tde: 0,
              vlr_fixo_tda: 0,
              taxa_pedagio: 0,
              vlr_pedagio: 0,
              vlr_tas: 0,
              vlr_despacho: 0,
              vlr_sec_cat: 0,
              vlr_agendamento: 0,
              vlr_outros: 0,
              ad_valorem: 0,
              vlr_minimo_advalorem: 0,
              vlr_minimo_gris: 0,
              vlr_qtde_docs_fiscais: 0,
              obs_valores: "",
              tafrvita_id: "",
              tabfrerotvig_id: "",
              status: 1,
              calculo: [
                {
                  vlr_ini: 0,
                  vlr_fim: 0,
                  vlr: 0,
                  fixa: 0,
                  excedente: 0,
                  vlr_exd: 0,
                  fator_conv: 0,
                  status: 1,
                  tabfrrotvicalc_id: ""
                }
              ],
              custo_extra: [
                {
                  custo: [],
                  tp_trecho: [],
                  tp_trecho_custo: [],
                  vlr_taxa: 0,
                  taxa_comissao: 0,
                  vlr_minimo: 0,
                  tafrvce_id: ""
                }
              ]
            }
          ]
        }
      ],
      form: new Form({
        cd: "",
        descr: "",
        obs: "",
        tp_composicao: [],
        tp_receita_despesa: 1,
        tp_calc: "",
        modal: [],
        tab_composicao: [],
        tp_tabela: 1,
        pessoa_id_for: "",
        tabfre_id: "",
        pessoa: [],
        rota: []
      }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    tpCalcSelected(obj) {
      this.form.tp_calc = obj.value;
    },
    fornecedorSelected(obj) {
      this.form.pessoa_id_for = obj.value;
    }
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.tabfre_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.fornecedorSelected = [];
      this.tpCalcSelected = [];
      this.rota = "";
      this.modal = "";
      this.tab_composicao = "";
      this.rota = [];
      this.modal = [];
      this.tab_composicao = [];
      this.pessoa = [];
      this.pessoa = "";
      this.errors_array = "";
      this.errors_array = [];
      this.addRowRota(0);
      this.$refs.modal_form.show();
    },
    onEdit(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.modal = "";
      this.modal = [];
      this.pessoa = "";
      this.pessoa = [];
      this.rota = "";
      this.rota = [];
      this.form.tabfre_id = data.tabfre_id;
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.tpCalcSelected = {
        label: data.tp_calculo.descr,
        value: data.tp_calculo.valor
      };
      this.form.tp_tabela = data.tp_tabela.valor;
      this.form.tp_receita_despesa = data.tp_receita_despesa.valor;
      this.form.tp_composicao = data.tp_composicao.valor;
      this.form.obs = data.obs;

      //Fornecedor
      if (data.pessoa_id_for !== null) {
        if (data.pessoa_fornecedor.pessoa_fisica !== null) {
          this.fornecedorSelected = {
            label:
              "PF -" +
              data.pessoa_fornecedor.pessoa_fisica.nome +
              " - " +
              data.pessoa_fornecedor.pessoa_fisica.cpf,
            value: data.pessoa_id_for
          };
        } else if (data.pessoa_fornecedor.pessoa_juridica !== null) {
          this.fornecedorSelected = {
            label:
              "PJ -" +
              data.pessoa_fornecedor.cd +
              " - " +
              data.pessoa_fornecedor.pessoa_juridica.razao_social +
              " - " +
              this.onFormataCnpj(
                data.pessoa_fornecedor.pessoa_juridica.cnpj_base,
                data.pessoa_fornecedor.pessoa_juridica.cnpj_filial,
                data.pessoa_fornecedor.pessoa_juridica.cnpj_digito
              ) +
              " - " +
              data.pessoa_fornecedor.pessoa_juridica.inscricao_estadual,
            value: data.pessoa_id_for
          };
        } else if (data.pessoa_fornecedor.pessoa_exterior !== null) {
          this.fornecedorSelected = {
            label:
              "PE -" +
              data.pessoa_fornecedor.pessoa_exterior.nome +
              " - " +
              data.pessoa_fornecedor.pessoa_exterior.cd,
            value: data.pessoa_id_for
          };
        }
      }

      // Modal
      if (data.tabela_frete_modal.length >= 1) {
        data.tabela_frete_modal.forEach(obj => {
          if (obj.status.valor == 1) {
            //somente ativos
            this.modal.push({
              label: obj.b_modal.descr,
              bmodal_id: obj.bmodal_id,
              status: obj.status.valor,
              tabfremod_id: obj.tabfremod_id
            });
          }
        });
      }

      //Clientes
      if (data.tabela_frete_pessoa.length >= 1) {
        data.tabela_frete_pessoa.forEach((item, i) => {
          if (item.pessoa.pessoa_fisica !== null) {
            if (item.status.valor == 1) {
              //somente ativos
              this.pessoa.push({
                label:
                  "PF -" +
                  item.pessoa.pessoa_fisica.nome +
                  " - " +
                  item.pessoa.pessoa_fisica.cpf,
                pessoa_id: item.pessoa_id,
                value: item.pessoa_id,
                status: item.status.valor,
                tafrvipes_id: item.tafrvipes_id
              });
            }
          } else if (item.pessoa.pessoa_juridica !== null) {
            if (item.status.valor == 1) {
              //somente ativos
              this.pessoa.push({
                label:
                  "PJ -" +
                  item.pessoa.cd +
                  " - " +
                  item.pessoa.pessoa_juridica.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    item.pessoa.pessoa_juridica.cnpj_base,
                    item.pessoa.pessoa_juridica.cnpj_filial,
                    item.pessoa.pessoa_juridica.cnpj_digito
                  ) +
                  " - " +
                  item.pessoa.pessoa_juridica.inscricao_estadual,
                pessoa_id: item.pessoa_id,
                value: item.pessoa_id,
                status: item.status.valor,
                tafrvipes_id: item.tafrvipes_id
              });
            }
          } else if (item.pessoa.pessoa_exterior !== null) {
            if (item.status.valor == 1) {
              //somente ativos
              this.pessoa.push({
                label:
                  "PE -" +
                  item.pessoa.pessoa_exterior.nome +
                  " - " +
                  item.pessoa.pessoa_exterior.cd,
                pessoa_id: item.pessoa_id,
                value: item.pessoa_id,
                status: item.status.valor,
                tafrvipes_id: item.tafrvipes_id
              });
            }
          }
        });
      }

      //Rota
        index.forEach((item, i) => {
        this.va_municipio_ori = null;
        this.va_municipio_des = null;
        this.va_regiao_ori = null;
        this.va_regiao_des = null;
        if (item.municipio_origem !== null) {
          this.va_municipio_ori = {
            label: item.municipio_origem.nome,
            value: item.municipio_origem.municipio_id
          };
          this.vb_disabled_regiao_origem = true;
        }
        if (item.municipio_destino !== null) {
          this.va_municipio_des = {
            label: item.municipio_destino.nome,
            value: item.municipio_destino.municipio_id
          };
          this.vb_disabled_regiao_destino = true;
        }
        if (item.regiao_origem !== null) {
          this.va_regiao_ori = {
            label: item.regiao_origem.descr,
            value: item.regiao_origem.regiao_id
          };
          this.vb_disabled_municipio_origem = true;
        }
        if (item.regiao_destino !== null) {
          this.va_regiao_des = {
            label: item.regiao_destino.descr,
            value: item.regiao_destino.regiao_id
          };
          this.vb_disabled_municipio_destino = true;
        }

        this.rota.push({
          municipio_origem: this.va_municipio_ori,
          municipio_destino: this.va_municipio_des,
          regiao_origem: this.va_regiao_ori,
          regiao_destino: this.va_regiao_des,
          tabfrerot_id: item.tabfrerot_id,
          status: item.status.valor,
          tp_origem: item.tp_origem,
          tp_destino: item.tp_destino,
          disabled_regiao_origem: this.vb_disabled_regiao_origem,
          disabled_regiao_destino: this.vb_disabled_regiao_destino,
          disabled_municipio_origem: this.vb_disabled_municipio_origem,
          disabled_municipio_destino: this.vb_disabled_municipio_destino,
          tp_operacao: item.tp_operacao.valor,
          tp_processo: item.tp_processo.valor,
          num_rota: i + 1,
          vigencia: [],
          carga: [],
          transp: []
        });
        if (item.tabela_frete_rota_meio_transp.length >= 0) {
          item.tabela_frete_rota_meio_transp.forEach((itemtransp, i_transp) => {
            this.rota[i].transp.push({
              carga_perigosa: itemtransp.carga_perigosa.valor,
              refrigerado: itemtransp.refrigerado.valor,
              status: itemtransp.status.valor,
              carroceria: {
                label: itemtransp.param_tipo_carroceria.descr,
                value: itemtransp.param_tipo_carroceria.partipcro_id
              },
              tp_rodado: {
                label: itemtransp.param_tipo_rodado.descr,
                value: itemtransp.param_tipo_rodado.partiprod_id
              },
              tafrerotvivei_id: itemtransp.tafrerotvivei_id
            });
          });
        }
        item.tabela_frete_rota_carga.forEach((itemcarga, i_carga) => {
          this.rota[i].carga.push({
            tp_carga: {
              label: itemcarga.tp_carga.descr,
              value: itemcarga.tp_carga.valor
            },
            param_tipo_carga: {
              label: itemcarga.param_tipo_carga.descr,
              value: itemcarga.param_tipo_carga.partipcar_id
            },
            status: itemcarga.status.valor,
            tafrvica_id: itemcarga.tafrvica_id
          });
        });
        item.tabela_frete_rota_vig.forEach((item2, i2) => {
          if (item2.status.valor == 2) {
            // se tiver vigencia aprovada, nao pode alterar a rota
            this.rota[i].disabled_regiao_origem = true;
            this.rota[i].disabled_regiao_destino = true;
            this.rota[i].disabled_municipio_origem = true;
            this.rota[i].disabled_municipio_destino = true;
          }
          this.rota[i].vigencia.push({
            dt_vigencia_ini: item2.dt_vigencia_ini,
            dt_vigencia_fim: item2.dt_vigencia_fim,
            obs_vigencia: item2.obs,
            tp_taxa_tde: {
              label: item2.tabela_frete_rota_vig_taxa.tp_taxa_tde.descr,
              value: item2.tabela_frete_rota_vig_taxa.tp_taxa_tde.valor
            },
            tp_taxa_tda: {
              label: item2.tabela_frete_rota_vig_taxa.tp_taxa_tda.descr,
              value: item2.tabela_frete_rota_vig_taxa.tp_taxa_tda.valor
            },
            status_taxa: item2.tabela_frete_rota_vig_taxa.status.valor,
            status: item2.status.valor,
            taxa_tda: parseFloat(item2.tabela_frete_rota_vig_taxa.taxa_tda),
            taxa_tde: parseFloat(item2.tabela_frete_rota_vig_taxa.taxa_tde),
            vlr_fixo_tda: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_fixo_tda
            ),
            vlr_fixo_tde: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_fixo_tde
            ),
            tp_taxa_pedagio: {
              label: item2.tabela_frete_rota_vig_taxa.tp_taxa_pedagio.descr,
              value: item2.tabela_frete_rota_vig_taxa.tp_taxa_pedagio.valor
            },
            taxa_pedagio: parseFloat(
              item2.tabela_frete_rota_vig_taxa.taxa_pedagio
            ),
            vlr_pedagio: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_pedagio
            ),
            taxa_gris: parseFloat(item2.tabela_frete_rota_vig_taxa.taxa_gris),
            taxa_devolucao: parseFloat(
              item2.tabela_frete_rota_vig_taxa.taxa_devolucao
            ),
            taxa_reentrega: parseFloat(
              item2.tabela_frete_rota_vig_taxa.taxa_reentrega
            ),
            vlr_tas: parseFloat(item2.tabela_frete_rota_vig_taxa.vlr_tas),
            vlr_despacho: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_despacho
            ),
            vlr_sec_cat: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_sec_cat
            ),
            vlr_agendamento: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_agendamento
            ),
            vlr_outros: parseFloat(item2.tabela_frete_rota_vig_taxa.vlr_outros),
            ad_valorem: parseFloat(item2.tabela_frete_rota_vig_taxa.ad_valorem),
            vlr_minimo_advalorem: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_minimo_advalorem
            ),
            qtde_docs_fiscais: item2.tabela_frete_rota_vig_taxa.qtde_docs_fiscais,
            vlr_qtde_docs_fiscais: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_qtde_docs_fiscais
            ),
            vlr_minimo_gris: parseFloat(
              item2.tabela_frete_rota_vig_taxa.vlr_minimo_gris
            ),
            obs_valores: item2.tabela_frete_rota_vig_taxa.obs,
            tabfrerotvig_id: item2.tabfrerotvig_id,
            tafrvita_id: item2.tabela_frete_rota_vig_taxa.tafrvita_id,
            calculo: [],
            custo_extra: []
          });
          item2.tabela_frete_rota_vig_calc.forEach((itemcalc, i_calc) => {
            this.rota[i].vigencia[i2].calculo.push({
              vlr_ini: parseFloat(itemcalc.vlr_ini),
              vlr_fim: parseFloat(itemcalc.vlr_fim),
              vlr: parseFloat(itemcalc.vlr),
              fixa: itemcalc.fixa,
              excedente: itemcalc.excedente,
              vlr_exd: parseFloat(itemcalc.vlr_exd),
              fator_conv: parseFloat(itemcalc.fator_conv),
              status: itemcalc.status.valor,
              tabfrrotvicalc_id: itemcalc.tabfrrotvicalc_id
            });
          });
          if (item2.tabela_frete_rota_vig_cus_ext.length >= 0) {
            item2.tabela_frete_rota_vig_cus_ext.forEach(
              (itemcustext, i_custext) => {
                this.rota[i].vigencia[i2].custo_extra.push({
                  custo: {
                    label: itemcustext.custo.descr,
                    value: itemcustext.custo.custo_id
                  },
                  tp_trecho: {
                    label: itemcustext.tp_trecho.descr,
                    value: itemcustext.tp_trecho.valor
                  },
                  tp_trecho_custo: {
                    label: itemcustext.tp_trecho_custo.descr,
                    value: itemcustext.tp_trecho_custo.valor
                  },
                  vlr_taxa: parseFloat(itemcustext.vlr_taxa),
                  taxa_comissao: parseFloat(itemcustext.taxa_comissao),
                  vlr_minimo: parseFloat(itemcustext.vlr_minimo),
                  tafrvce_id: itemcustext.tafrvce_id
                });
              }
            );
          }
        });
      });

      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.rota.forEach(obj => {
        obj.vigencia.forEach(obj2 => {
          obj2.dt_vigencia_ini = this.formatDateSubmit(obj2.dt_vigencia_ini);
          obj2.dt_vigencia_fim = this.formatDateSubmit(obj2.dt_vigencia_fim);
        });
      });
      this.form.rota = this.rota;
      this.form.modal = this.modal;
      this.form.pessoa = this.pessoa;
      this.form.tab_composicao = this.tab_composicao;
      this.form
        .put("/api/tabelafrete/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          console.log(errors);
          for (var property in errors) {
            console.log(property);
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.rota.forEach(obj => {
        obj.vigencia.forEach(obj2 => {
          obj2.dt_vigencia_ini = this.formatDateSubmit(obj2.dt_vigencia_ini);
          obj2.dt_vigencia_fim = this.formatDateSubmit(obj2.dt_vigencia_fim);
        });
      });
      this.form.rota = this.rota;
      this.form.modal = this.modal;
      this.form.pessoa = this.pessoa;
      this.form.tab_composicao = this.tab_composicao;
      this.form
        .patch("/api/tabelafrete/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          this.showPopover = true;
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/tabelafrete/status")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          this.showPopover = true;
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    addRowCustoExtra: function(index_rota, index_vig, e) {
      e.preventDefault();
      this.rota[index_rota].vigencia[index_vig].custo_extra.push({
        custo: [],
        tp_trecho: [],
        tp_trecho_custo: [],
        vlr_taxa: 0,
        vlr_minimo: 0,
        taxa_comissao: 0
      });
    },
    removeRowCustoExtra: function(index_rota, index_vig, index_custo_extra) {
      this.rota[index_rota].vigencia[index_vig].custo_extra.splice(
        index_custo_extra,
        1
      );
    },
    addRowTransp: function(index_rota, e) {
      e.preventDefault();
      this.rota[index_rota].transp.push({
        tp_rodado: [],
        refrigerado: 2,
        carroceria: [],
        carga_perigosa: 2,
        status: 1
      });
    },
    removeRowTransp: function(index_rota, index_transp) {
      this.rota[index_rota].transp.splice(index_transp, 1);
    },
    addRowCarga: function(index_rota, e) {
      e.preventDefault();
      this.rota[index_rota].carga.push({
        param_tipo_carga: [],
        tp_carga: [],
        status: 1
      });
    },
    removeRowCarga: function(index_rota, index_carga) {
      this.rota[index_rota].carga.splice(index_carga, 1);
    },
    addRowCalculo: function(index_rota, index_vig, e) {
      e.preventDefault();
      this.rota[index_rota].vigencia[index_vig].calculo.push({
        vlr_ini: 0,
        vlr_fim: 0,
        vlr: 0,
        fixa: 0,
        excedente: 0,
        vlr_exd: 0,
        fator_conv: 0,
        status: 1
      });
    },
    removeRowCalculo: function(index_rota, index_vig, index_calc) {
      this.rota[index_rota].vigencia[index_vig].calculo.splice(index_calc, 1);
    },
    addRowVigencia: function(index_rota, vig, e) {
      e.preventDefault();
      this.rota[index_rota].vigencia.push({
        dt_vigencia_ini: "",
        dt_vigencia_fim: "",
        obs_vigencia: "",
        status: 1,
        taxa_gris: 0,
        taxa_devolucao: 0,
        taxa_reentrega: 0,
        taxa_tda: 0,
        taxa_tde: 0,
        vlr_fixo_tde: 0,
        vlr_fixo_tda: 0,
        taxa_pedagio: 0,
        vlr_pedagio: 0,
        vlr_tas: 0,
        vlr_despacho: 0,
        vlr_sec_cat: 0,
        vlr_agendamento: 0,
        vlr_outros: 0,
        ad_valorem: 0,
        vlr_minimo_advalorem: 0,
        vlr_minimo_griss: 0,
        num_vig: vig.num_vigencia + 1,
        tp_taxa_tde: { label: "Não se aplica", value: 1 },
        tp_taxa_tda: { label: "Não se aplica", value: 1 },
        tp_taxa_pedagio: { label: "Não se aplica", value: 1 },
        calculo: [
          {
            vlr_ini: vig.calculo[0].vlr_ini,
            vlr_fim: vig.calculo[0].vlr_fim,
            vlr: 0,
            fixa: 0,
            excedente: 0,
            vlr_exd: 0,
            fator_conv: 0,
            status: 1
          }
        ],
        custo_extra: []
      });
    },
    removeRowVigencia: function(index_rota, index_vig) {
      this.rota[index_rota].vigencia.splice(index_vig, 1);
    },
    addRowRota: function(num_rota) {
      this.rota.push({
        num_rota: num_rota + 1,
        municipio_origem: [],
        municipio_destino: [],
        regiao_origem: [],
        regiao_destino: [],
        status: 1,
        disabled_regiao_origem: false,
        disabled_regiao_destino: false,
        disabled_municipio_origem: false,
        disabled_municipio_destino: false,
        tp_operacao: 1,
        tp_processo: 1,
        transp: [],
        carga: [
          { tp_carga: [], tafrvica_id: "", status: 1, param_tipo_carga: [] }
        ],
        vigencia: [
          {
            dt_vigencia_ini: "",
            dt_vigencia_fim: "",
            obs_vigencia: "",
            num_vig: 1,
            status: 1,
            tp_taxa_tde: { label: "Não se aplica", value: 1 },
            tp_taxa_tda: { label: "Não se aplica", value: 1 },
            tp_taxa_pedagio: { label: "Não se aplica", value: 1 },
            taxa_gris: 0,
            taxa_devolucao: 0,
            taxa_reentrega: 0,
            taxa_tda: 0,
            taxa_tde: 0,
            vlr_fixo_tde: 0,
            vlr_fixo_tda: 0,
            taxa_pedagio: 0,
            vlr_pedagio: 0,
            vlr_tas: 0,
            vlr_despacho: 0,
            vlr_sec_cat: 0,
            vlr_agendamento: 0,
            vlr_outros: 0,
            ad_valorem: 0,
            vlr_minimo_advalorem: 0,
            vlr_minimo_griss: 0,
            calculo: [
              {
                vlr_ini: 0,
                vlr_fim: 0,
                vlr: 0,
                fixa: 0,
                excedente: 0,
                vlr_exd: 0,
                fator_conv: 0,
                status: 1
              }
            ],
            custo_extra: []
          }
        ]
      });
    },
    removeRowRota: function(index_rota) {
      this.rota.splice(index_rota, 1);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/tabelafrete/jsonlistgeral")
        .then(response => {
          response.tp_calc.forEach(obj => {
            this.optionsLivTpCalc.push({ label: obj.descr, value: obj.valor });
          });
          response.tp_tabela.forEach(obj => {
            this.optionsTpTabela.push({ text: obj.descr, value: obj.valor });
          });
          response.status_vigencia.forEach(obj => {
            this.optionsStatusVigencia.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.regiao.forEach(obj => {
            this.optionsRegiao.push({ label: obj.descr, value: obj.regiao_id });
          });
          response.status_veiculo.forEach(obj => {
            this.optionsStatusVeiculo.push({
              text: obj.descr,
              value: obj.valor
            });
          });
          response.carga_perigosa.forEach(obj => {
            this.optionsCargaPerigosa.push({
              text: obj.descr,
              value: obj.valor
            });
          });
          response.refrigerado.forEach(obj => {
            this.optionsRefrigerado.push({ text: obj.descr, value: obj.valor });
          });
          response.param_tipo_rodado.forEach(obj => {
            this.optionsParamTipoRodado.push({
              label: obj.descr,
              value: obj.partiprod_id
            });
          });
          response.param_tipo_carga.forEach(obj => {
            this.optionsParamTipoCarga.push({
              label: obj.descr,
              value: obj.partipcar_id
            });
          });
          response.tp_carga.forEach(obj => {
            this.optionsTpCarga.push({ label: obj.descr, value: obj.valor });
          });
          response.status_carga.forEach(obj => {
            this.optionsStatusCarga.push({ text: obj.descr, value: obj.valor });
          });
          response.taxa_status.forEach(obj => {
            this.optionsTaxaStatus.push({ text: obj.descr, value: obj.valor });
          });
          response.taxa_tp_taxa_tde.forEach(obj => {
            this.optionsTaxaTpTaxaTde.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.taxa_tp_taxa_tda.forEach(obj => {
            this.optionsTaxaTpTaxaTda.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.taxa_tp_taxa_pedagio.forEach(obj => {
            this.optionsTaxaTpTaxaPedagio.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.pessoa_status.forEach(obj => {
            this.optionsStatusPessoa.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.extra_tp_trecho.forEach(obj => {
            this.optionsExtraTpTrecho.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.extra_tp_trecho_custo.forEach(obj => {
            this.optionsExtraTpTrechoCusto.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.custo.forEach(obj => {
            this.optionsCusto.push({ label: obj.descr, value: obj.custo_id });
          });
          response.modal.forEach(obj => {
            this.optionsModal.push({
              label: obj.descr,
              bmodal_id: obj.bmodal_id
            });
          });
          response.tp_composicao.forEach(obj => {
            this.optionsLivTpComposicao.push({
              text: obj.descr,
              value: obj.valor
            });
          });
          response.tp_receita_despesa.forEach(obj => {
            this.optionsLivTpReceitaDespesa.push({
              text: obj.descr,
              value: obj.valor
            });
          });
          response.carroceria.forEach(obj => {
            this.optionsCarroceria.push({
              label: obj.descr,
              value: obj.partipcro_id
            });
          });
          response.municipio.forEach(obj => {
            this.optionsMunicipio.push({
              label: obj.nome,
              value: obj.municipio_id
            });
          });
          response.status_calc.forEach(obj => {
            this.optionsLivStatusCalc.push({
              text: obj.descr,
              value: obj.valor
            });
          });
          response.tp_operacao.forEach(obj => {
            this.optionsTpOperacao.push({ text: obj.descr, value: obj.valor });
          });
          response.tp_processo.forEach(obj => {
            this.optionsTpProcesso.push({ text: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    defineOrigemDestino(
      index,
      valor,
      local,
      tipo //querido eu do futuro, me desculpe, dava pra fazer melhor; eu sei.
    ) {
      if (local == 1) {
        //municipio
        if (tipo == 1) {
          //origem
          if (valor !== null) {
            this.rota[index].tp_origem = 1;
            this.rota[index].disabled_regiao_origem = true;
          } else {
            this.rota[index].disabled_regiao_origem = false;
          }
        } else if (tipo == 2) {
          //destino
          if (valor !== null) {
            this.rota[index].tp_destino = 1;
            this.rota[index].disabled_regiao_destino = true;
          } else {
            this.rota[index].disabled_regiao_destino = false;
          }
        }
      }
      if (local == 2) {
        //regiao
        if (tipo == 1) {
          //origem
          if (valor !== null) {
            this.rota[index].tp_origem = 2;
            this.rota[index].disabled_municipio_origem = true;
          } else {
            this.rota[index].disabled_municipio_origem = false;
          }
        } else if (tipo == 2) {
          //destino
          if (valor !== null) {
            this.rota[index].tp_destino = 2;
            this.rota[index].disabled_municipio_destino = true;
          } else {
            this.rota[index].disabled_municipio_destino = false;
          }
        }
      }
      this.optionsMunicipio.splice;
    },
    ordenaTabelasFrete(tipo) {
      this.optionsTabelaFreteRepopulada = [];
      if (tipo == 2) {
        //Tabela composta
        this.optionsTabelaFrete.forEach((item, i) => {
          if (item.tp_composicao == 3) {
            //Tabela de composição
            this.optionsTabelaFreteRepopulada.push({
              label: item.descr,
              value: item.tabfre_id
            });
          }
        });
      } else if (tipo == 3) {
        //Tabela de composicao
        this.optionsTabelaFrete.forEach((item, i) => {
          if (item.tp_composicao == 2) {
            //Tabela composta
            this.optionsTabelaFreteRepopulada.push({
              label: item.descr,
              value: item.tabfre_id
            });
          }
        });
      } else {
        //
      }
    },
    listaFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFornecedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then(response => {
            this.optionsFornecedor = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach(obj => {
                this.optionsFornecedor.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach(obj => {
                this.optionsFornecedor.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach(obj => {
                this.optionsFornecedor.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            this.isLoadingFornecedor = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesPessoa(search) {
      if (search.length >= 3) {
        this.isLoadingPessoa = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then(response => {
            this.optionsPessoa = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach(obj => {
                this.optionsPessoa.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach(obj => {
                this.optionsPessoa.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach(obj => {
                this.optionsPessoa.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            this.isLoadingPessoa = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>